import api from "../ApiConfig";
import { Apis } from '../../config';
import { NotificationManager } from 'react-notifications';
import unauthService from "../unauth";


const CreateUser= async (data) => {
    try {
        const result = await api.post(Apis.GetUserRegsiter, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        if(result.data.success){
            
            NotificationManager.success(result.data.message);
        }
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const GetUserList = async (data) => {
    try {
        const result = await api.get(Apis.GetAllUserList, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const DeleteUser = async (id) => {
    try {
        const result = await api.delete(Apis.GetDeleteUserList+'?id='+id,  {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        // let parsedData=JSON.parse(result)
        
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success('Article Deleted successfully', 'Success')
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const GetUserListPage = async (filterVal) => {
    try {
        console.log(filterVal)
        const result = await api.get(`${Apis.GetAllUserList}/filter/?searchText=${filterVal.searchText}&pageNumber=${filterVal.pageNumber}&pageSize=${filterVal.pageSize}`, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        console.log('response---',response)
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return response.additionalData   
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const UpdateUser = async (data,id) => {
    try {
        const result = await api.put(Apis.GetUserUpdate+'?id='+id, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success("User updated Successfully");
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};


export default {
    CreateUser,
    GetUserList,
    GetUserListPage,
    DeleteUser,
    UpdateUser
};